// src/pages/pessoas/FornecedorSearch.js
import React, { useEffect, useState } from 'react';
import { useFornecedor } from '../../contexts/pessoas/FornecedorContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import LazyLoading from '../../components/modalForm/LazyLoading';
import ModalTable from '../../components/modalForm/ModalTable';

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const FornecedorSearch = ({ show, onHide, onSelectFornecedor }) => {
    const { fornecedores } = useFornecedor();
    const [filter, setFilter] = useState('');
    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    useEffect(() => {
        if (show) {
            setFilter('');
        }
    }, [show]);

    if (!show) return null;

    const normalizeString = (str) => {
        return str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    };

    const filteredFornecedores = fornecedores.filter(f =>
        normalizeString(f.pessoa?.nome).includes(normalizeString(filter))
    );

    const sortedFornecedores = filteredFornecedores.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'nome') {
            const nomeA = a.pessoa?.nome.toLowerCase();
            const nomeB = b.pessoa?.nome.toLowerCase();
            if (nomeA < nomeB) return sortDirection === 'asc' ? -1 : 1;
            if (nomeA > nomeB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (fornecedor) => {
        onSelectFornecedor(fornecedor);
        onHide();
    };

    return (
        <ModalContainer show={show} largura="600px" variant="busca" onHide={onHide}>

            <ModalHeader title="Buscar Fornecedor" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        type="text"

                        placeholder="Filtrar por nome..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        autoFocus
                    />
                </div>

                <LazyLoading
                    items={sortedFornecedores}
                    resetKey={`${filter}|${sortField}|${sortDirection}`}
                >
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable
                    containerRef={containerRef}
                    containerStyle={{ maxHeight: '55vh', overflowY: 'auto' }}
                    onContainerScroll={handleScroll}
                >
                    <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('id')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '60%' }} aria-sort={sortField === 'nome' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('nome')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Nome
                                    {sortField === 'nome' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(fornecedor => (
                            <tr key={fornecedor.id} onDoubleClick={() => handleDoubleClick(fornecedor)}>
                                <td className="text-end align-middle">{fornecedor.id}</td>
                                <td className="text-start align-middle">{fornecedor.pessoa?.nome}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectFornecedor(fornecedor)} style={{ padding: '2px 6px' }} label={fornecedor.pessoa?.nome} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">
                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>

        </ModalContainer>
    );
};

export default FornecedorSearch;
